class GenderSwitchFooter extends HTMLElement {
  constructor() {
    super();
    
    this.genderSettings = this.getGenderCookieSettings();
    this.elTriggerMen = this.querySelector('[data-trigger-men]');
    this.elTriggerWomen = this.querySelector('[data-trigger-women]');
    this.elTriggerToggle = this.querySelector('[data-trigger-toggle]');

    switch (Cookies.get(this.genderSettings.cookieName)) {
      case this.genderSettings.cookieValueMen:
        this.triggerToggle('m');
        this.checkMenuGender('m');
        break;
      case this.genderSettings.cookieValueWomen:
        this.triggerToggle('w');
        this.checkMenuGender('w');
        break;
      default:
        this.triggerToggle('w');
        this.checkMenuGender('w');
        break;
    }

    this.elTriggerMen.addEventListener('click', e => {
      this.triggerToggle('m');
      setTimeout(() => {
        location.href = this.genderSettings.cookieUrlMen;
      }, 500);
    });
    this.elTriggerWomen.addEventListener('click', e => {
      this.triggerToggle('w');
      setTimeout(() => {
        location.href = this.genderSettings.cookieUrlWomen;
      }, 500);
    });
    this.elTriggerToggle && this.elTriggerToggle.addEventListener('click', e => {
      this.triggerToggle();
    });

  }


  getGenderCookieSettings() {
    return JSON.parse(document.querySelector('[data-gender-cookie-settings]').textContent);
  }

  triggerToggle(gender) {

    if (gender) {
      switch (gender) {
        case 'm':
          Cookies.set(this.genderSettings.cookieName, this.genderSettings.cookieValueMen, this.genderSettings.cookieDuration);
          window.gender = this.genderSettings.cookieValueMen;
          window.i18nGender = this.genderSettings.i18nMen;
          this.elTriggerMen.setAttribute('active', '');
          this.elTriggerWomen.removeAttribute('active');
          if( this.elTriggerToggle ){
            this.elTriggerToggle.removeAttribute('data-women-active');
            this.elTriggerToggle.setAttribute('data-men-active', '');
          }
          break;
        case 'w':
          Cookies.set(this.genderSettings.cookieName, this.genderSettings.cookieValueWomen, this.genderSettings.cookieDuration);
          window.gender = this.genderSettings.cookieValueWomen;
          window.i18nGender = this.genderSettings.i18nWomen;
          this.elTriggerMen.removeAttribute('active');
          this.elTriggerWomen.setAttribute('active', '');
          if( this.elTriggerToggle ){
            this.elTriggerToggle.removeAttribute('data-men-active');
            this.elTriggerToggle.setAttribute('data-women-active', '');
          }
          break;
      }
    } else {
      switch (Cookies.get(this.genderSettings.cookieName)) {
        case this.genderSettings.cookieValueMen:
          this.triggerToggle('w');
          setTimeout(() => {
            location.href = this.genderSettings.cookieUrlWomen;
          }, 500);
          break;
        case this.genderSettings.cookieValueWomen:
          this.triggerToggle('m');
          setTimeout(() => {
            location.href = this.genderSettings.cookieUrlMen;
          }, 500);
          break;
      }
    }

  }
  
  checkMenuGender(gender){
    /* On mobile - check if a menu element is specific for Men or Women (like shoes)*/
    /* the check by tag is to execute this function only for one element */
    if( this.tagName.toLowerCase() != "gender-switch-footer" ) return false;
    
    /*mobile only*/
    let mediaMobile = window.matchMedia( "(max-width: 768px)" );
    //if( !mediaMobile.matches ) return false;
    
    const array_labels_men = ['men', 'herren', 'hommes', 'heren', 'mężczyźni'];
    const array_labels_women = ['women', 'damen', 'femmes', 'dames', 'kobiety'];
    
    let mobile_menu_first_row = document.body.querySelectorAll('.header .store-links > li');
    mobile_menu_first_row.forEach(nav_link => {
      var nav_link_title = nav_link.getAttribute('data-title') && nav_link.getAttribute('data-title').toLowerCase();
      if( nav_link_title && array_labels_women.includes(nav_link_title) ){
        if(gender == 'w'){
          nav_link.style.order = "-1";
          /* //rename 'Women shoes' to 'Shoes' and hide 'Men shoes'
          let new_label = nav_link.querySelector('a').childNodes[0];
          let new_label__go_back = nav_link.querySelector('.go-back').lastChild;
          let label_i18n = this.getAttribute('data-main-products-type');
          new_label.textContent = label_i18n ? label_i18n : 'Shoes';
          new_label__go_back.textContent = new_label.textContent;
          */
        } else {
          nav_link.style.order = "";
          //nav_link.style.display = "none";
        }
      }
      else if( nav_link_title && array_labels_men.includes(nav_link_title) ){
        let p = nav_link.querySelector('a').childNodes[0];
        let l = this.getAttribute('data-main-products-type');
        if(gender == 'm'){
          nav_link.style.order = "-1";
          /* //rename 'Men shoes' to 'Shoes' and hide 'Women shoes'
          let new_label = nav_link.querySelector('a').childNodes[0];
          let new_label__go_back = nav_link.querySelector('.go-back').lastChild;
          let label_i18n = this.getAttribute('data-main-products-type');
          new_label.textContent = label_i18n ? label_i18n : 'Shoes';
          new_label__go_back.textContent = new_label.textContent;
          */
        } else {
          nav_link.style.order = "";
          //nav_link.style.display = "none";
        }
      }
    });
  }

}

customElements.define('gender-switch-footer', class extends GenderSwitchFooter{});
customElements.define('gender-switch-header', class extends GenderSwitchFooter{});
